import qs from 'qs';

import { serviceApi } from '../service';
import { appointmentTypeApi } from '../appointment-types';

const appointmentUrl = (appointmentTypeId, queryParams) =>
  `${appointmentTypeApi.appointmentTypeUrl(appointmentTypeId)}/appointment?${qs.stringify(
    queryParams,
    { skipNulls: true },
  )}`;

const createAppointment = (appointmentTypeId, appointmentDraft) =>
  serviceApi.fetch(appointmentUrl(appointmentTypeId), {
    method: 'POST',
    body: { ...appointmentDraft },
  });

const updateAppointment = (appointmentTypeId, request) =>
  serviceApi.fetch(appointmentUrl(appointmentTypeId), {
    method: 'PUT',
    body: { ...request },
  });

const getAppointment = (storeId, appointmentTypeIds, bypassErrorCodes = []) =>
  serviceApi.fetchJSON(
    appointmentUrl(appointmentTypeIds, { storeId }),
    { method: 'GET' },
    undefined,
    bypassErrorCodes,
  );

const deleteAppointment = (storeId, appointmentTypeId, bypassErrorCodes = [404]) =>
  serviceApi.fetch(
    appointmentUrl(appointmentTypeId, { storeId }),
    { method: 'DELETE' },
    undefined,
    bypassErrorCodes,
  );

export const appointmentApi = {
  createAppointment,
  updateAppointment,
  getAppointment,
  deleteAppointment,
};
